module.exports = __webpack_public_path__ + "static/media/Tutorial-1.87ccc035.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tutorial/Tutorial-1.png
// module id = 828
// module chunks = 0